import React, { useEffect, useState, useRef } from 'react';
// import { reactPlugin } from '../../appInsights';
// import { withAITracking } from '@microsoft/applicationinsights-react-js';
import cn from 'clsx';
import { gritComponentStyles } from './gritComponentStyles';
import DeleteIcon from '@mui/icons-material/Delete';
import { TextComponent, SelectComponent } from '../uiComponents';
import { Enumeration } from '../../xmlParsing/interfaces';
import Button from '@mui/material/Button';
import { SelectChangeEvent } from '@mui/material';
import { isEqual } from 'lodash';

// declare all characters
const characters: string = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
const generateString = () => {
  let result = '';
  const charactersLength = characters.length;
  for (let i = 0; i < 5; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

interface EnumerationListProps {
  list: Enumeration[];
  onChangeEnumeration: (data: Enumeration[]) => void;
}
function EnumerationList({ list, onChangeEnumeration }: EnumerationListProps) {
  const origData = useRef(list);

  const [enumObject, setEnumObject] = useState<Record<string, Enumeration>>({});
  const [valueList, setValueList] = useState<string[]>([]);
  const [textList, setTextList] = useState<string[]>([]);
  const classes = gritComponentStyles();

  useEffect(() => {
    const _temp = list.reduce((acc: Record<string, Enumeration>, element: Enumeration) => {
      acc[generateString()] = element;
      return acc;
    }, {});
    setEnumObject(_temp);
  }, [origData]);

  useEffect(() => {
    let _valList: string[] = [];
    let _textList: string[] = [];
    let a = Object.keys(enumObject).map((k) => {
      _valList.push(enumObject[k]['value']);
      _textList.push(enumObject[k]['text']);
      return enumObject[k];
    });
    setValueList(_valList);
    setTextList(_textList);
    !isEqual(origData.current, a) && onChangeEnumeration(a);
  }, [enumObject]);

  const getValueError = (val: string) => {
    let res: string = val != '' ? '' : 'Value cannot be empty';
    if (res === '') {
      return valueList.reduce(
        (acc: number, curVal: string) => (curVal.toLowerCase() === val.toLowerCase() ? (acc += 1) : acc),
        0,
      ) === 2
        ? 'Another enum exists with the same value'
        : '';
    }
    return res;
  };

  const getTextError = (val: string) => {
    let res: string = val != '' ? '' : 'Display text cannot be empty';
    if (res === '') {
      return textList.reduce(
        (acc: number, curVal: string) => (curVal.toLowerCase() === val.toLowerCase() ? (acc += 1) : acc),
        0,
      ) === 2
        ? 'Another enum exists with the same text'
        : '';
    }
    return res;
  };

  const onDeleteEnumeration = (id: string) => {
    setEnumObject(
      Object.keys(enumObject).reduce(
        (acc: any, curVal: string) => (curVal != id ? { ...acc, [curVal]: enumObject[curVal] } : acc),
        {},
      ),
    );
  };

  return (
    <>
      {Object.keys(enumObject).length > 0 &&
        Object.keys(enumObject).map((id: string) => {
          return (
            <div key={'enum-' + id} className={cn(classes.flexCol)}>
              <div className={cn(classes.flexRow)}>
                <TextComponent
                  changeHandler={(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
                    setEnumObject({ ...enumObject, [id]: { ...enumObject[id], ['value']: e.target.value } });
                  }}
                  data={{
                    value: enumObject[id]['value'] || '',
                    label: 'Value',
                    error: !!getValueError(enumObject[id]['value'].trim()),
                    style: { margin: 1, width: 200 },
                    helperText: getValueError(enumObject[id]['value'].trim()),
                  }}
                />
                <TextComponent
                  changeHandler={(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
                    setEnumObject({ ...enumObject, [id]: { ...enumObject[id], ['text']: e.target.value } });
                  }}
                  data={{
                    value: enumObject[id]['text'] || '',
                    label: 'Text',
                    error: !!getTextError(enumObject[id]['text'].trim()),
                    style: { margin: 1, width: 200 },
                    helperText: getTextError(enumObject[id]['text'].trim()),
                  }}
                />
                <SelectComponent
                  changeHandler={(e: SelectChangeEvent<string>) => {
                    setEnumObject({
                      ...enumObject,
                      [id]: { ...enumObject[id], ['selectByDefault']: e.target.value == 'true' ? true : false },
                    });
                  }}
                  data={{
                    value: enumObject[id]['selectByDefault']?.toString(),
                    label: 'SelectByDefault',
                    style: { margin: 1, width: 200 },
                    options: [
                      { label: 'true', value: 'true' },
                      { label: 'false', value: 'false' },
                    ],
                  }}
                />
                <DeleteIcon
                  style={{ marginTop: '20px' }}
                  onClick={() => {
                    window.confirm(
                      'Are you sure you want to delete ' + enumObject[id]['value'] + '? This cannot be undone.',
                    ) && onDeleteEnumeration(id);
                  }}
                  className={classes.icon}
                  color="error"
                />
              </div>
            </div>
          );
        })}
      {Object.keys(enumObject).length < 2 && (
        <div style={{ marginLeft: '10px' }} className={classes.error}>
          There should be atleast 2 enumerations defined.
        </div>
      )}
      <div style={{ marginLeft: '10px', marginBottom: '10px' }} className={classes.flexRow}>
        <Button
          variant="contained"
          onClick={() => {
            setEnumObject({ ...enumObject, [generateString()]: { value: '', text: '', selectByDefault: false } });
          }}
        >
          Add Enumeration
        </Button>
      </div>
    </>
  );
}

// export default withAITracking(reactPlugin, EnumerationList);
export default EnumerationList;
